const link = "https://scrollon.onrender.com"
// const link = "https://416f996cfaa093795d47b11677c3a9f7.loophole.site"

export default link;